import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListItem } from './list-item.interface';

@Component({
  selector: 'umkt-list-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss',
})
export class ListItemComponent {
  @Input() items: ListItem[] = [];
  @Input() selectedItemId: string | null = null;
  @Input() showDividers: boolean = true;
  @Input() dividerColor: string = '#e0e0e0';
  @Input() textColor: string = '#666666';
  @Input() activeTextColor: string = '#e74c3c';
  @Input() iconColor: string = '#e74c3c';
  @Input() padding: string = '16px';
  @Input() fontSize: string = '16px';
  @Input() fontWeight: string = '400';

  @Output() itemSelected = new EventEmitter<string>();

  onItemClick(item: ListItem): void {
    if (!item.disabled) {
      this.itemSelected.emit(item.id);
      if (item.onClick) {
        item.onClick();
      }
    }
  }

  isItemActive(item: ListItem): boolean {
    return this.selectedItemId === item.id;
  }
}
